import React from "react";

const Error = ({ error, chainId, manualError, fundsError, deniedError }) => {
	return (
		<div className="fixed z-50 w-full bg-red-500 text-center text-lg font-semibold capitalize">
			{(error && error.name && error.name === "ChainIdNotAllowedError"
				? "You need to be on the Ethereum Mainnet."
				: error && error.message) ||
				(manualError && manualError.split(":")[1]) ||
				(fundsError && fundsError) ||
				(deniedError && deniedError)}
		</div>
	);
};

export default Error;
